import { TaskModalCreateView } from "./TaskModalCreateView";
import { TaskModalLoadedView } from "./TaskModalLoadedView";

type TaskModalMode = "view" | "edit" | "create";

interface TaskModalProps {
    mode: TaskModalMode;
    taskId?: number;
    onClose: () => void;
}

export function TaskModal({ mode, taskId, onClose }: TaskModalProps) {
    if (mode === "create") {
        return <TaskModalCreateView onClose={onClose} />;
    }

    if (taskId === undefined) {
        return null;
    }

    return <TaskModalLoadedView key={taskId} mode={mode} taskId={taskId} onClose={onClose} />;
}
